var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProcore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.54883C16 3.16643 15.7797 2.25859 15.219 1.68088C14.6583 1.22696 13.7772 1 12.3354 1H3.66458C2.22278 1 1.32165 1.22696 0.780975 1.68088C0.220274 2.1348 0 3.06327 0 4.54883V12.4512C0 13.8336 0.220274 14.7414 0.780975 15.3191C1.34168 15.773 2.22278 16 3.66458 16H12.3354C13.7772 16 14.6783 15.773 15.219 15.3191C15.7797 14.8652 16 13.9367 16 12.4512V10.5117H12.3354L10.8736 13.132H5.5269L2.86358 8.44841L5.5269 3.74415H10.8736L12.3154 6.38514H15.98V4.54883H16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43335 8.5098L6.90273 11H9.96396L11.4333 8.5098L9.96396 6H6.90273L5.43335 8.5098Z",
    fill: "#F47E42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProcore);
export default __webpack_public_path__ + "static/media/icon--procore.4844fdeb77373805eebd4d42de241615.svg";
export { ForwardRef as ReactComponent };